// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__UddE1","label":"Radio_label__2usS-","checkMark":"Radio_checkMark__1b6LN","disabled":"Radio_disabled__EsAJq"};